import { Select } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';

import type { TOption } from '../../../../dashboard/features/controls/types';
import styles from '../BasicParameters.module.scss';
import type { BasicParametersStore } from '../BasicParameters.store';
import type { ParameterLine } from '../ParameterLine.store';

interface Props {
  line: ParameterLine;
  store: BasicParametersStore;
}

const renderLogLabel = (label: string, run?: string) => (
  <>
    {label}
    {run && <span className={styles.circleLong}>{run}</span>}
  </>
);

export const LogSelect = observer(function LogSelect({ line, store }: Props) {
  const { isBaseParamsLoading } = store;

  return (
    <Select
      loading={line.isLoading || isBaseParamsLoading}
      disabled={!line.supplier.value || line.isLoading || isBaseParamsLoading}
      key={`${line.parameterType}-log`}
      onSelect={(_, option) => {
        line.setLog(option as TOption);
      }}
      options={line.logsOptions}
      optionRender={(option) => renderLogLabel(String(option.label), option.data.run)}
      labelRender={({ value, label }) => {
        const option = line.logsOptions.find((op) => op.value === value);
        return option ? renderLogLabel(option.label, option.run) : label;
      }}
      sortOptions
      value={line.log.value?.id}
    />
  );
});
